import $ from 'jquery';

(function() { // Begin scoping function

  // Number of the current slide
  let PRCurrentSlide;

  // Stores the interval of bowl swaps
  let PRInterval;

  // Number of slides
  const PRNumberOfSlides = $('.panel-press-reviews-slide:last-of-type').data('slide');

  function PRMoveToSlide(slide) {

    // If we are switching to a new slide...
    if (PRCurrentSlide != slide) {

      $('.panel-press-reviews-slide').removeClass('panel-press-reviews-slide-selected');
      $('.panel-press-reviews-navigation-button').removeClass('panel-press-reviews-navigation-button-selected');

      // Set new nav
      $(`.panel-press-reviews-slide[data-slide=${slide}]`).addClass('panel-press-reviews-slide-selected');
      $(`.panel-press-reviews-navigation-button[data-slide=${slide}]`).addClass('panel-press-reviews-navigation-button-selected');

      // Record new current slide
      PRCurrentSlide = slide;
    }

  }

  function PRNextSlide() {
    if (PRCurrentSlide == PRNumberOfSlides) {
      PRMoveToSlide(1);
    } else {
      PRMoveToSlide(PRCurrentSlide + 1);
    }
  }

  $(document).ready(() => {
    PRMoveToSlide(1);

    // Set periodic slide rotation
    PRInterval = setInterval(PRNextSlide, 8000);

  });

  $('.panel-press-reviews-slide, .panel-press-reviews-navigation-button').click(function() {
    const moveTo = $(this).data('slide');
    PRMoveToSlide(moveTo);
    clearInterval(PRInterval);
    PRInterval = setInterval(PRNextSlide, 8000);
  });

})(); // End scoping function
